"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import css from "./header-menu.module.scss";
import { Cta, NavItem, SiteSettings, TrustBar } from "@/sanity/sanity.types";
import Image from "@/components/common/image/image";
import Link, { LinkType } from "../../link/link";
import { usePathname } from "next/navigation";
import useScrollLock from "@/hooks/useScrollLock";
import { getTrackingInfo } from "@/components/amc-pixel/amc-pixel-utils";
import { formatPhone } from "@/utilities/formatPhoneNumber";
import SubMenuContent from "./sub-menu-content/sub-menu-content";
import useBreakpoint from "@/hooks/useBreakpoint";
import { useLayout } from "@/contexts/layout-context";
import imageUrl from "@/sanity/utilities/imageUrl";
export type NavItemWithKey = {
  _key: string;
} & NavItem;
interface IHeaderSlideMenuProps {
  data: NavItemWithKey[];
  primaryCta?: Cta;
  className?: string;
  trustBar?: TrustBar;
}
const HeaderMenu = props => {
  const $ = _c(69);
  const {
    data,
    className,
    trustBar
  } = props;
  const pathname = usePathname();
  const {
    setLocked
  } = useScrollLock();
  const {
    setNavOpen
  } = useLayout();
  const {
    md
  } = useBreakpoint();
  const [open, setOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [subMenuActive, setSubMenuActive] = useState(null);
  const [, setTrackingInfo] = useState(null);
  const footerData = trustBar?.badges?.map(_temp) ?? [];
  let t0;
  if ($[0] !== md || $[1] !== open || $[2] !== setLocked || $[3] !== setNavOpen || $[4] !== subMenuOpen) {
    t0 = () => {
      if (subMenuOpen) {
        setSubMenuOpen(false);
      }
      setOpen(!open);
      setNavOpen(!open);
      if (!md) {
        setLocked(!open);
      }
    };
    $[0] = md;
    $[1] = open;
    $[2] = setLocked;
    $[3] = setNavOpen;
    $[4] = subMenuOpen;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const toggleMenu = t0;
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = item => {
      setSubMenuActive(item);
      setSubMenuOpen(true);
    };
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const openSubMenu = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSubMenuOpen(false);
    };
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const closeSubMenu = t2;
  let t3;
  if ($[8] !== subMenuOpen) {
    t3 = () => {
      if (!subMenuOpen) {
        setSubMenuActive(null);
      }
    };
    $[8] = subMenuOpen;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onSubMenuTransitionEnd = t3;
  let t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const fetchTrackingInfo = async () => {
        const info = await getTrackingInfo();
        setTrackingInfo(info);
      };
      fetchTrackingInfo();
    };
    t5 = [];
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== md || $[13] !== setLocked || $[14] !== setNavOpen) {
    t6 = () => {
      setOpen(false);
      setSubMenuActive(null);
      setSubMenuOpen(false);
      setNavOpen(false);
      if (!md) {
        setLocked(false);
      }
    };
    $[12] = md;
    $[13] = setLocked;
    $[14] = setNavOpen;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== pathname) {
    t7 = [pathname];
    $[16] = pathname;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  useEffect(t6, t7);
  const t8 = `${css.burgerContainer} ${className ?? ""}`;
  let t9;
  if ($[18] !== open) {
    t9 = !open ? <Image src="/burger-menu.svg" alt="Toggle menu" width={32} height={32} /> : <Image src="/close.svg" alt="Close menu" width={24} height={24} className={css.menuIcon} />;
    $[18] = open;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9 || $[21] !== toggleMenu) {
    t10 = <button className="flex w-[32px] items-center" onClick={toggleMenu} aria-label="Toggle menu">{t9}</button>;
    $[20] = t9;
    $[21] = toggleMenu;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = `${css.menu} ${open ? css.show : ""}`;
  const t12 = !open;
  const t13 = !open;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className={css.menuHeaderGradient} />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = css;
  let t16;
  if ($[24] !== data || $[25] !== pathname) {
    let t17;
    if ($[27] !== pathname) {
      t17 = (item_0, index) => {
        if (!item_0.link) {
          return null;
        }
        const hasChildren = !!item_0.children?.length;
        return <li key={item_0._key ?? index} className={css.navItem}>{hasChildren ? <button type="button" className={css.navLinkButton} onClick={() => openSubMenu(item_0)} data-cta-id={item_0?.link?.ctaId ?? ""} data-cta-value={item_0?.link?.ctaValue ?? ""}><span>{item_0.link.label}</span><Image src="/caret-right.svg" alt="" width={32} height={32} className={css.menuIcon} /></button> : <Link className={`${css.navLink} ${pathname === item_0.link.href ? css.navLinkActive : ""}`} href={item_0.link.href ?? ""} data-cta-id={item_0?.link?.ctaId ?? ""} data-cta-value={item_0?.link?.ctaValue ?? ""} rel={item_0?.link?.nofollow}>{item_0.link.label}</Link>}</li>;
      };
      $[27] = pathname;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    t16 = data.map(t17);
    $[24] = data;
    $[25] = pathname;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[29] !== t16) {
    t17 = <ul className={css.navList}>{t16}</ul>;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  const t18 = css;
  const t19 = footerData.map(_temp2);
  let t20;
  if ($[31] !== t18.menuFooter || $[32] !== t19) {
    t20 = <div className={t18.menuFooter}>{t19}</div>;
    $[31] = t18.menuFooter;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t15.menuContent || $[35] !== t17 || $[36] !== t20) {
    t21 = <div className={t15.menuContent}>{t17}{t20}</div>;
    $[34] = t15.menuContent;
    $[35] = t17;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  const t22 = props?.primaryCta?.link?.ctaId ?? "";
  const t23 = props?.primaryCta?.link?.ctaValue ?? "";
  const t24 = props?.primaryCta?.link?.nofollow;
  let t25;
  if ($[38] !== t22 || $[39] !== t23 || $[40] !== t24) {
    t25 = <div className={css.menuApply}><Link href="https://apply.amerisave.com/quote/v1/home" linkType={LinkType.BUTTON} className="h-[56px] !w-full" data-cta-id={t22} data-cta-value={t23} rel={t24}>Apply Now</Link></div>;
    $[38] = t22;
    $[39] = t23;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t21 || $[47] !== t25) {
    t26 = <nav className={t11} aria-hidden={t12} inert={t13}>{t14}{t21}{t25}</nav>;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t21;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  const t27 = `${css.subMenuOverlay} ${subMenuOpen ? css.subMenuShow : ""}`;
  const t28 = !subMenuActive;
  const t29 = !subMenuActive;
  let t30;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className={css.subMenuHeaderGradient} />;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Image src="/arrow-back.svg" alt="" width={24} height={24} className={css.menuIcon} />;
    $[50] = t31;
  } else {
    t31 = $[50];
  }
  let t32;
  if ($[51] !== closeSubMenu) {
    t32 = <div className={css.subMenuHeader}><button type="button" onClick={closeSubMenu} aria-label="Back to menu">{t31}</button></div>;
    $[51] = closeSubMenu;
    $[52] = t32;
  } else {
    t32 = $[52];
  }
  let t33;
  if ($[53] !== subMenuActive) {
    t33 = <SubMenuContent subMenuActive={subMenuActive} />;
    $[53] = subMenuActive;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  let t34;
  if ($[55] !== t32 || $[56] !== t33) {
    t34 = <div className={css.subMenu} onClick={_temp3}>{t30}{t32}{t33}</div>;
    $[55] = t32;
    $[56] = t33;
    $[57] = t34;
  } else {
    t34 = $[57];
  }
  let t35;
  if ($[58] !== onSubMenuTransitionEnd || $[59] !== t27 || $[60] !== t28 || $[61] !== t29 || $[62] !== t34) {
    t35 = <div className={t27} aria-hidden={t28} inert={t29} role="presentation" onTransitionEnd={onSubMenuTransitionEnd}>{t34}</div>;
    $[58] = onSubMenuTransitionEnd;
    $[59] = t27;
    $[60] = t28;
    $[61] = t29;
    $[62] = t34;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t10 || $[65] !== t26 || $[66] !== t35 || $[67] !== t8) {
    t36 = <div className={t8}>{t10}{t26}{t35}</div>;
    $[64] = t10;
    $[65] = t26;
    $[66] = t35;
    $[67] = t8;
    $[68] = t36;
  } else {
    t36 = $[68];
  }
  return t36;
};
export default HeaderMenu;
function _temp(badge) {
  return {
    key: badge._key,
    icon: badge.image?.asset,
    url: badge.link?.href,
    text: badge.label,
    rel: badge.link?.nofollow
  };
}
function _temp2(item_1, index_0) {
  return <a key={index_0} className={css.menuFooterLink} href={item_1.url} rel="nofollow">{item_1?.icon && <Image src={imageUrl(item_1?.icon).url()} alt="" width={24} height={24} className={css.menuIcon} />}<span>{item_1.text}</span></a>;
}
function _temp3(e) {
  return e.stopPropagation();
}